import React from "react";
import {CCard, CCardBody, CCol} from "@coreui/react";
import DataGridCrudBase from "../components/datagrid/DataGridCrudBase";
import Toasts from "../components/notificacion/Toasts";
import ContenedoresService from "../services/contenedores.service";
import {DataGrid, esES, GridActionsCellItem, GridToolbarContainer} from "@mui/x-data-grid";
import ContenedorModal from "../components/modals/Contenedor";
import {Button} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {StateContext} from "../components/context/StateProvider";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import HostService from "../services/host.service";
import {RUTAS} from "../config/constants";

class Contenedores extends DataGridCrudBase {

    static contextType = StateContext;

    constructor(props) {
        super(props);
        this.state = {
            contenedoresModels: {},
            contenedores: [],
            modelGrid: 'contenedoresModels',
            stateGrid: 'contenedores',
            loading: true,
            showContenedor:false,
            contenedorEdit: null
        };
        this.apiRef = React.createRef();
        this.apiRef.current = {};
    }

    async componentDidMount() {
        const {state, updateState} = this.context;

        // Obtener contenedores
        await ContenedoresService.obtenerContenedores(state.year).then(
            (contenedores) => {
                this.setState({contenedores: contenedores, loading: false});
            }
        ).catch((error) => {
            const toasts = Toasts.generateToast(error.message, 'error');
            updateState({toasts: [...state.toasts, toasts]})
        });
    }


    generateColumns() {
        return [
            {
                field: 'id',
                headerName: 'ID',
                flex: 0.5,
                editable: false,
                type: 'number'
            },
            {
                field: 'contenedor',
                headerName: 'Contenedor',
                flex: 0.75,
                editable: false
            },
            {
                field: 'concepto',
                headerName: 'Concepto',
                flex: 1,
                editable: false
            },
            {
                field: 'preparador',
                headerName: 'Preparador',
                flex: 0.75,
                editable: false
            },
            {
                field: 'almacen',
                headerName: 'Almacén',
                flex: 0.5,
                editable: false
            },
            {
                field: 'fecha_llegada_muelle',
                headerName: 'Llegada muelle',
                flex: 1,
                type: 'dateTime',
                valueGetter: (params) => params.row.fecha_llegada_muelle ? new Date(params.row.fecha_llegada_muelle) : null,
            },
            {
                field: 'naviera',
                headerName: 'Naviera',
                flex: 1,
                editable: false
            },
            {
                field: 'fecha_llegada',
                headerName: 'Fecha llegada',
                flex: 1,
                type: 'dateTime',
                valueGetter: (params) => params.row.fecha_llegada ? new Date(params.row.fecha_llegada) : null,
            },
            {
                field: 'fecha_aviso',
                headerName: 'Fecha aviso',
                flex: 1,
                type: 'dateTime',
                valueGetter: (params) => params.row.fecha_aviso ? new Date(params.row.fecha_aviso) : null,
            },
            {
                field: 'fecha_salida',
                headerName: 'Fecha salida',
                flex: 1,
                type: 'dateTime',
                valueGetter: (params) => params.row.fecha_salida ? new Date(params.row.fecha_salida) : null,
            },
            {
                field: 'tipo_operacion',
                headerName: 'Ope',
                flex: 0.45,
                editable: false,
                valueGetter: (params) => params.row.es_exportacion ? 'Exp' : 'Imp',
            },
            // {
            //     field: 'ejercicio',
            //     headerName: 'Ejercicio',
            //     flex: 0.5,
            //     type: 'number',
            //     editable: false
            // },
            {
                field: 'documentos',
                headerName: 'Documentos',
                flex: 1.25,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    const documentos = params.row.documentos || [];

                    return (
                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                            {documentos.map((doc) => (
                                <a
                                    key={doc.id}
                                    href={`${HostService.getHost()}${RUTAS.IMAGENES}/${doc.ruta}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title={doc.nombre}
                                    download
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    {doc.url}
                                    <InsertDriveFileIcon fontSize="small"  />
                                </a>
                            ))}
                        </div>
                    );
                },
            },
            {
                field: 'actions',
                type: 'actions',
                headerName: '',
                flex: 0.5,
                cellClassName: 'actions',
                getActions: ({id}) => {

                    return [
                        <GridActionsCellItem
                            icon={<EditIcon />}
                            label="Edit Contenedor"
                            className="textPrimary"
                            onClick={() => this.handleContenedor(id)}
                            color="inherit"
                        />,
                        <GridActionsCellItem
                            icon={<DeleteIcon/>}
                            label="Delete"
                            onClick={() => this.handleDelete(id)}
                            color="inherit"
                        />,
                    ];
                },
            }
        ];
    }

    editToolbar = () => {
        return (
            <GridToolbarContainer>
                <Button startIcon={<AddIcon/>} className='bg-primary text-white mb-3' onClick={() => {
                    this.handleContenedorNew();
                }}>
                    Añadir contenedor
                </Button>
            </GridToolbarContainer>
        );
    }

    handleContenedorNew() {
        this.setState({showContenedor: true});
    }

    handleClose = async (show) => {
        this.setState({ [show]: false, contenedorEdit: null });
    }

    handleContenedor(id) {
        const contenedor = this.state.contenedores.find(c => c.id === id);
        this.setState({ contenedorEdit: contenedor, showContenedor: true });
    }

    handleDelete = async (id) => {
        const { state, updateState } = this.context;

        try {
            await ContenedoresService.eliminarContenedor(id);

            const toasts = Toasts.generateToast('Contenedor eliminado correctamente', 'success');
            updateState({ toasts: [...state.toasts, toasts] });

            this.setState((prevState) => ({
                contenedores: prevState.contenedores.filter((c) => c.id !== id),
            }));
        } catch (error) {
            const toasts = Toasts.generateToast(error.message, 'error');
            updateState({ toasts: [...state.toasts, toasts] });
        }
    }

    handleDeleteDocumento = async (idContenedor, idDocumento) => {
        const { state, updateState } = this.context;

        try {
            await ContenedoresService.eliminarDocumentoContenedor(idContenedor, idDocumento);

            const toasts = Toasts.generateToast('Documento eliminado correctamente', 'success');
            updateState({ toasts: [...state.toasts, toasts] });

            this.setState((prevState) => ({
                contenedores: prevState.contenedores.map((contenedor) => {
                    if (contenedor.id === idContenedor) {
                        const contenedorActualizado = {
                            ...contenedor,
                            documentos: contenedor.documentos.filter(doc => doc.id !== idDocumento)
                        };
                        this.setState({ contenedorEdit: contenedorActualizado });
                        return contenedorActualizado;
                    }
                    return contenedor;
                })
            }));
        } catch (error) {
            const toasts = Toasts.generateToast(error.message, 'error');
            updateState({ toasts: [...state.toasts, toasts] });
        }
    }

    handleConfirm = async (contenedor) => {

        const {state, updateState} = this.context;

        try {
            let toasts;
            if (contenedor.id) {
                const contenedorActualizado = await ContenedoresService.actualizarContenedor(contenedor);
                toasts = Toasts.generateToast('Contenedor actualizado correctamente', 'success');

                this.setState((prevState) => ({
                    contenedores: prevState.contenedores.map((c) =>
                        c.id === contenedor.id ? { ...contenedorActualizado } : c
                    ),
                }));
            } else {
                const nuevoContenedor = await ContenedoresService.registrarContenedor(contenedor);
                toasts = Toasts.generateToast('Contenedor registrado correctamente', 'success');

                this.setState((prevState) => ({
                    contenedores: [nuevoContenedor, ...prevState.contenedores],
                }));
            }

            updateState({toasts: [...state.toasts, toasts]});
            this.handleClose('showContenedor');

        } catch (error) {
            const toasts = Toasts.generateToast(error.message, 'error');
            updateState({toasts: [...state.toasts, toasts]})
        }

    }

    render() {

        const {
            showContenedor,
        } = this.state;

        return(
            <CCol id="contenedores" className='data-grid-container' md={12}>
                <CCard className="p-3">
                    <CCardBody>
                        <DataGrid
                            rows={this.state.contenedores}
                            columns={this.generateColumns()}
                            rowModesModel={this.state.contenedoresModels}
                            localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                            editMode="row"
                            apiRef={this.apiRef}
                            autoHeight={true}
                            slots={{
                                toolbar: this.editToolbar,
                            }}
                            initialState={{
                                columns: {
                                    columnVisibilityModel: {
                                        id: false,
                                    },
                                },
                                sorting: {
                                    sortModel: [{field: 'id', sort: 'desc'}],
                                }
                            }}
                            loading={this.state.loading}
                        />
                    </CCardBody>
                </CCard>

                <ContenedorModal show={showContenedor}
                                 handleConfirm={(contenedor) => this.handleConfirm(contenedor)}
                                 handleClose={() => this.handleClose('showContenedor')}
                                 contenedorInicial={this.state.contenedorEdit}
                                 handleDeleteDocumento={(idContenedor,idDocumento) => this.handleDeleteDocumento(idContenedor,idDocumento)}
                ></ContenedorModal>
            </CCol>
        )
    }
}

export default Contenedores;